/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState} from 'react';
import {Swiper, SwiperSlide} from "swiper/react";
import {FreeMode, Navigation, Pagination, Thumbs} from "swiper";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";

const ThumbSlider = (props) => {

    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    return (
        <>
            { props.images.length > 0 &&  <>
                <Swiper
                    thumbs={{ swiper: thumbsSwiper }}
                    modules={[FreeMode, Navigation, Pagination, Thumbs]}
                    spaceBetween={0}
                    pagination={{ clickable: true }}
                    navigation={true}
                    slidesPerView={1}
                    className='UsedPartsSlider'>
                    {
                        props.images.map((item, index) => {
                            return(
                                <SwiperSlide key={index}>
                                    <img src={item.image} alt='slide' />
                                </SwiperSlide>
                            );
                        })
                    }
                </Swiper>
                <Swiper
                    onSwiper={setThumbsSwiper}
                    spaceBetween={10}
                    slidesPerView={4}
                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="mySwiper UsedPartsSliderThumbs"
                >
                    {
                        props.images.map((item, index) => {
                            return(
                                <SwiperSlide key={index}>
                                    <img src={item.image} alt='slide' />
                                </SwiperSlide>
                            );
                        })
                    }
                </Swiper>
            </>
            }
            {/*{ adImages.length > 0 && <Swiper*/}
            {/*    spaceBetween={0}*/}
            {/*    pagination={true}*/}
            {/*    navigation={true}*/}
            {/*    slidesPerView={1}*/}
            {/*    modules={[Navigation, Pagination]}*/}
            {/*    className='UsedCarsSlider'>*/}
            {/*    {*/}
            {/*        adImages.map((item, index) => {*/}
            {/*            return(*/}
            {/*                <SwiperSlide key={index}>*/}
            {/*                    <img className="swiper-lazy" src={item.image} alt='slide'/>*/}
            {/*                </SwiperSlide>*/}
            {/*            );*/}
            {/*        })*/}
            {/*    }*/}
            {/*</Swiper> }*/}
        </>
    );
};

export default ThumbSlider;